const hamburger = document.querySelector('[data-behaviour="header-menu-open"]');
const menu = document.querySelector('[data-ref="header-menu"]')
const tablet = 768;
if (hamburger && menu) {
	hamburger.addEventListener('click', () => {
		hamburger.classList.toggle('hamburger--open');
		menu.classList.toggle('header__menu--active');
	});

	window.addEventListener('resize', function(e){
		if (menu.classList.contains('header__menu--active')) {
			hamburger.classList.remove('hamburger--open');
			menu.classList.remove('header__menu--active');
		}
		if (window.innerWidth < tablet) {
			
		}
	});
}